import React from 'react';

import { DossierDtoAdminFonctionnel } from 'lib_api/lib/api/gen';

import UpdateDonneesJudiciaires from 'components/UpdateDonneesJudiciaires/UpdateDonneesJudiciaires';
import { useApi } from 'hooks/ApiStoreContext';
import { useDossierAdminContext } from 'hooks/dossierAdmin/DossierAdminContext';
import { useDossierCompletAdmin } from 'hooks/dossierAdmin/useDownloadDossierCompletAdminFonctionnel';

interface UpdateDonneesJudiciairesProps {
  closeModal: () => void;
}

function UpdateDonneesJudiciairesAdminFonctionnel({
  closeModal,
}: UpdateDonneesJudiciairesProps): React.ReactElement {
  const [{ result, setDossier: setDossierHook }, { fetchEvents }] =
    useDossierAdminContext();
  const dossierId = result.id;
  const {
    dossier: dossierAdmin,
    fetchInProgress,
    fetchDossier,
    errorOccured,
  } = useDossierCompletAdmin(dossierId);
  const { AdminFonctionnelControllerApi: adminController } = useApi();

  async function setDossier(dossier: DossierDtoAdminFonctionnel) {
    setDossierHook(dossier);
    await fetchEvents();
  }

  return (
    <UpdateDonneesJudiciaires
      closeModal={closeModal}
      controller={adminController}
      dossierId={dossierId}
      setDossier={setDossier}
      fetchDossierInProgress={fetchInProgress}
      fetchDossier={fetchDossier}
      errorOccured={errorOccured}
      dossierBody={dossierAdmin?.dossier.body}
    />
  );
}

export default UpdateDonneesJudiciairesAdminFonctionnel;
